import React from 'react';

import SelectInputV2 from '../select/select-input-v2/select-input-v2.component';

const ID = 'operator-select';
export interface OperatorSelectProps {
    type: 'arithmetic' | 'comparison' | 'assignment';
    value?: string;
    id?: string;
    required?: boolean;
    label?: string;
    helpMessage?: React.ReactNode;
    onChange: (value: string) => void;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
}
const arithmetic = ['+', '-', '*', '/', '%', '**', '//'];
const comparison = ['==', '!=', '>', '<', '>=', '<='];
const assignment = ['=', '+=', '-=', '*=', '/=', '%=', '**=', '//=', '&=', '|=', '^=', '<<=', '>>='];

export const OperatorSelect = (props: OperatorSelectProps) => {
    const options = props.type === 'arithmetic' ? arithmetic : props.type === 'comparison' ? comparison : assignment;
    const mappedOptions = options.map((o) => ({ value: o, label: o }));
    return (
        <SelectInputV2
            id={props.id || ID}
            label={props.label || 'Operator'}
            helpMessage={props.helpMessage}
            className={props.className}
            required={props.required}
            options={mappedOptions}
            onSelect={(option) => props.onChange(option?.value ?? '')}
            value={props.value}
            isClearable={props.isClearable}
        />
    );
};
